import { ref, Ref, reactive } from '@vue/composition-api';
import Vue from 'vue';
import qs from 'qs';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import shareAccessTokenManager from '@/renderer/scripts/utils/AccessTokenManager/share';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import { loopAsyncTask } from '@/renderer/scripts/utils/syncTask';
import { authAndLogin } from '@/renderer/scripts/utils/meeting/autoLoginInMeeting';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
interface SaveOnMobileSchemeParams {
  path: string;
  shareToken: string;
  extracCode: string;
  selectedCode: string;
}
interface SaveDetail {
  list: CoFile.SaveToNetDiscDataItem[];
  show: boolean;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const handler = (vm: Vue) => {
  const shareToken = vm.$route.params?.shareToken;
  const showSelectTargetFolder: Ref<boolean> = ref(false);
  let selectedList: any[] = [];
  const saveDetail: SaveDetail = reactive({
    list: [],
    show: false,
  });

  /**
   * 通过 scheme 唤起移动客户端
   */
  const openMobileClient = (parmas: SaveOnMobileSchemeParams) => {
    // TODO: 等移动端协议确定下来后再改
    const BASE_URL = 'cofile://com.tencent.cofile/main?';
    const queryString = qs.stringify(parmas);
    const URL = BASE_URL + queryString;
    dispatchRouter(URL, 'location');
  };

  /**
   * 移动 Web 端处理[保存至网盘]
   */
  const handlerSaveOnMobile = async () => {
    const paths = [...selectedList[0].path];
    paths.pop();
    const items = selectedList.map(item => item.name);
    // 移动 Web 端逻辑
    // step 1 获取 accessToken
    const info = await shareAccessTokenManager.get(shareToken);
    const { accessToken } = info;
    try {
      // step 2 发送后端请求换取 code
      const res = await smh.userAPI.saveShareCode({
        paths,
        items,
        accessToken,
      });
      const { code: selectedCode } = res.data;
      // step 3 唤起客户端
      openMobileClient({
        path: '/file/saveas',
        shareToken,
        extracCode: vm.$store.getters.extractCode,
        selectedCode,
      });
    } catch (error) {
      tips.error(error as MsgError);
    }
  };

  /**
   * 移动 PC 端处理[保存至网盘]
   */
  const handlerSaveOnPC = () => {
    // 判断是否登录
    if (!vm.$store.getters.isLogined) {
      tips.info(i18n_t('请先登录后继续操作'));
      if (vm.$store.getters.isInWeMeetApp) {
        // 会议里直接授权登录
        setTimeout(() => {
          authAndLogin((params: any) => {
            dispatchRouter(params, 'replace');
          });
        }, 600);
      } else {
        vm.$emit('show-login-dialog');
      }
      return;
    }
    showSelectTargetFolder.value = true;
  };
  const methods = {
    handleSaveToNetDisc: async (list: any[]) => {
      selectedList = list;
      // 因暂时app未发布，故此处不区分移动端，均在网页端内进行处理
      // if (vm.$store.getters.isMobile) {
      //   handlerSaveOnMobile();
      // } else {
      //   handlerSaveOnPC();
      // }
      handlerSaveOnPC();
    },
    async save(params: { spaceId: string; dirPath: string }) {
      const { spaceId, dirPath } = params;
      saveDetail.show = false;
      saveDetail.list = [];
      showSelectTargetFolder.value = false;
      tips.loading(i18n_t('保存中'), 0);
      const info = await shareAccessTokenManager.get(shareToken);
      const { accessToken: shareAccessToken, libraryId: copyFromLibraryId, spaceId: copyFromSpaceId } = info;
      const batchList: SMH.BatchCopyItem[] = selectedList.map(item => ({
        copyFromSpaceId,
        copyFromLibraryId,
        copyFrom: item.path.join('/'),
        to: `${dirPath}/${item.path[item.path.length - 1]}`,
        conflictResolutionStrategy: 'rename',
      }));
      try {
        // @ts-ignore
        const { data, status } = await smh.commonAPI.saveToCloudDisk(
          {
            spaceId,
            shareAccessToken,
          },
          {
            body: batchList,
          },
        );
        if (status === 200) {
          tips.success(i18n_t('保存成功'));
          return;
        }
        if (status === 207) {
          data?.result[0]?.code && tips.error(data?.result[0]?.code);
        }
        if (status === 202) {
          const res = await loopAsyncTask(smh.commonAPI.asyncTaskQuery, data.taskId, spaceId);
          const { result } = res;
          saveDetail.list = result || [];
          saveDetail.show = true;
          tips.closeAll();
        }
      } catch (error) {
        tips.error(error as MsgError);
      }
    },
  };
  return {
    showSelectTargetFolder,
    saveDetail,
    methods,
  };
};
export default handler;
